// extracted by mini-css-extract-plugin
module.exports = {"accordion":"AttributeAccordion_accordion__1HDCf","labelHighlight":"AttributeAccordion_labelHighlight__1LwhG"};